// useClickLogger.ts
import { useEffect, useRef } from "react";
import moment from "moment";
import { networkLoggingService } from "./network-logging-service";
import { SessionStorageExistence } from "./storage";
const useClickLogger = () => {
    // TODO - Due to s3 changes we have removed this. we will implement later.
    return;
    const elementRef = useRef(null);
    useEffect(() => {
        const handleClick = (event) => {
            let frontendLogs = [];
            let logStorage = SessionStorageExistence("logs");
            if (logStorage.isExist) {
                frontendLogs = logStorage.data;
            }
            const targetElement = elementRef.current;
            if (targetElement && targetElement.contains(event.target)) {
                const target = event.target;
                const getTextContent = (element) => {
                    if (!element)
                        return "";
                    const textContent = element.innerText || element.textContent || "";
                    if (textContent.trim() === "" && element.parentElement) {
                        return getTextContent(element.parentElement);
                    }
                    return textContent.trim();
                };
                const elementText = getTextContent(target);
                const currentRoute = window.location.pathname;
                const log = {
                    elementText,
                    currentRoute,
                };
                frontendLogs.push({
                    uxLog: log,
                    date: moment().format("DD MMM YYYY, h:mm:ss a"),
                });
                sessionStorage.setItem("logs", JSON.stringify(frontendLogs));
            }
        };
        const { cleanup } = networkLoggingService();
        const element = elementRef.current;
        if (element) {
            element.addEventListener("click", handleClick);
        }
        return () => {
            if (element) {
                element.removeEventListener("click", handleClick);
            }
            cleanup();
        };
    }, []);
    return elementRef;
};
export default useClickLogger;
